import DevicesIcon from '@mui/icons-material/Devices';
import LockResetIcon from '@mui/icons-material/LockReset';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { AppBar, Logout, MenuItemLink, UserMenu } from 'react-admin';
import { ChainButton, NotificationPanel } from '../../components';
import { getChainId, getEmployeeType } from '../../lib';
import getChainName from '../../lib/getChainName';
import getPlaceName from '../../lib/getPlaceName';
import { EmployeeType } from '../../models';

const ConfigurationMenu = React.forwardRef<any, any>((props, ref) => {
    return (
        <>
            <MenuItemLink
                ref={ref}
                primaryText="Alterar Senha"
                to="/change-password"
                leftIcon={<LockResetIcon sx={{ width: '1em', height: '1em' }} />}
                sx={{ paddingLeft: '10px' }}
                onClick={props.onClick}
            />
            <MenuItemLink
                primaryText="Meus dispositivos"
                to="/device-sessions"
                leftIcon={<DevicesIcon sx={{ width: '1em', height: '1em' }} />}
                sx={{ paddingLeft: '10px' }}
                onClick={props.onClick}
            />
            <Logout />
        </>
    );
});

const CustomUserMenu = (props: any) => (
    <UserMenu {...props}>
        <ConfigurationMenu />
    </UserMenu>
);

const MyAppBar = () => {
    const employeeType = getEmployeeType();

    return (
        <AppBar color="primary" userMenu={<CustomUserMenu />}>
            <Typography
                variant="h6"
                color="inherit"
                sx={{
                    flex: 1,
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                }}
                id="react-admin-title"
            />

            {(employeeType === EmployeeType.chain && getChainId()) &&
                <NotificationPanel />
            }

            <Typography sx={{ marginRight: 2.5 }}>{getPlaceName()}</Typography>
            {
                [EmployeeType.admin, EmployeeType.retailer].includes(employeeType) ?
                    <ChainButton />
                    :
                    <Typography>{getChainName()}</Typography>
            }
        </AppBar>
    );
};

export default MyAppBar;